import { render, staticRenderFns } from "./StLoading.vue?vue&type=template&id=2cf8ddef&"
import script from "./StLoading.vue?vue&type=script&lang=js&"
export * from "./StLoading.vue?vue&type=script&lang=js&"
import style0 from "./StLoading.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports